import { createSlice } from "@reduxjs/toolkit";
import { LegalAndRegTextInterface } from "../../components/LegalAndRegulatorText/types";

interface props {
  isFetching: boolean,
  legalAndRegTexts: LegalAndRegTextInterface[],
  error: []
}

const initialState: props = {
  isFetching: false,
  legalAndRegTexts: [],
  error: []
}

const legalAndRegTextSlice = createSlice({
  name: "legalAndRegTexts",
  initialState,
  reducers: {
    statusLegalAndRegTextStart: (state) => {
      state.isFetching = false
      state.error = []
    },
    statusLegalAndRegTextSuccess: (state, action) => {
      state.isFetching = false
      state.legalAndRegTexts = action.payload
      state.error = []
    },
    statusLegalAndRegTextFailure: (state, action) => {
      state.isFetching = false
      state.error = action.payload
    }
  }
})


export const { 
  statusLegalAndRegTextStart,
  statusLegalAndRegTextSuccess,
  statusLegalAndRegTextFailure 
} = legalAndRegTextSlice.actions

export default legalAndRegTextSlice.reducer